type FilterSidebarProps = {
  genres: string[];
  years: string[];
  countries: string[];
  selectedGenres: string[];
  selectedYears: string[];
  selectedCountries: string[];
  resultCount: number;
  onToggle: (group: 'genre' | 'year' | 'country', value: string) => void;
  onReset: () => void;
};

const Group = ({
  title,
  options,
  selected,
  group,
  onToggle,
}: {
  title: string;
  options: string[];
  selected: string[];
  group: 'genre' | 'year' | 'country';
  onToggle: (group: 'genre' | 'year' | 'country', value: string) => void;
}) => (
  <div>
    <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
      <span className="h-3.5 w-1 rounded-full bg-accent-500"></span>
      {title}
    </h3>
    <div className="mt-3 flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = selected.includes(opt);
        return (
          <button
            key={opt}
            type="button"
            onClick={() => onToggle(group, opt)}
            aria-pressed={active}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${
              active
                ? 'border-primary-500 bg-primary-500 text-background-50'
                : 'border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700'
            }`}
          >
            {opt}
          </button>
        );
      })}
    </div>
  </div>
);

export default function FilterSidebar({
  genres,
  years,
  countries,
  selectedGenres,
  selectedYears,
  selectedCountries,
  resultCount,
  onToggle,
  onReset,
}: FilterSidebarProps) {
  const hasFilter =
    selectedGenres.length > 0 || selectedYears.length > 0 || selectedCountries.length > 0;

  return (
    <aside className="w-full lg:w-64 lg:shrink-0">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="flex items-center justify-between">
          <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
            <i className="ri-filter-3-line text-primary-600"></i>
            筛选条件
          </h2>
          {hasFilter && (
            <button
              type="button"
              onClick={onReset}
              className="text-xs font-medium text-accent-600 transition-colors hover:text-accent-700 whitespace-nowrap"
            >
              重置
            </button>
          )}
        </div>

        <p className="mt-2 text-xs text-foreground-500">
          共筛选出 <span className="font-semibold text-foreground-800">{resultCount}</span> 部作品
        </p>

        <div className="mt-5 flex flex-col gap-6">
          <Group
            title="类型"
            options={genres}
            selected={selectedGenres}
            group="genre"
            onToggle={onToggle}
          />
          <Group
            title="年代"
            options={years}
            selected={selectedYears}
            group="year"
            onToggle={onToggle}
          />
          <Group
            title="国家 / 地区"
            options={countries}
            selected={selectedCountries}
            group="country"
            onToggle={onToggle}
          />
        </div>
      </div>
    </aside>
  );
}